import { jwtDecode } from 'jwt-decode'

export const captureTokenFromResponse = (response) => {
  const authHeader = response.headers.authorization
  if (authHeader && authHeader.startsWith('Bearer ')) {
    const token = authHeader.substring('Bearer '.length)
    localStorage.setItem('authToken', token)
  }
}

export const getCurrentUser = () => {
  const token = localStorage.getItem('authToken')
  if (!token) return null

  try {
    const payload = jwtDecode(token)

    return {
      id: parseInt(payload.sub),
      email: payload.email,
      role: payload.role
    }
  } catch {
    return null
  }
}

export const isAdmin = () => {
  return getCurrentUser()?.role === "admin";
}

export const clearToken = () => {
  localStorage.removeItem('authToken')
}

export const getToken = () => {
  return localStorage.getItem('authToken')
}
